import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditVaultQuestionsPageNew from "../../components/VaultQuestions/AddVaultQuestionsPageNew";



const EditvaultQuestionsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Vault Questions" link2="/vault-questions" title="Edit Vault Question" />


        <EditVaultQuestionsPageNew/>


      </MasterLayout>
    </>
  );
};

export default EditvaultQuestionsPage;
